import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const StyledRow = styled(Flexer.Parent).attrs(() => ({ alignItems: 'center' }))`
  background: #fff;
  border: 1px solid var(--greyMouse);
  ${({ clickable }) => clickable && 'cursor: pointer;'}
  & + & {
    border-top: 0;
  }
`;

export default StyledRow;
